export default __webpack_public_path__ + "static/media/screenShots_jewelry-3.2008bbaa.jpg";